<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light" v-if="canViewDriverAll">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchDriver" class="form-inline my-2 my-lg-0">
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        confirm
                        placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด">
                    </date-picker>&nbsp;&nbsp;
                    <b-form-select v-model="search.transport_type"
                                   :options="transportType">
                    </b-form-select>
                    &nbsp
                    <multiselect
                        v-model="search.driver"
                        class="form-control border-0"
                        placeholder="ค้นหาคนขับ"
                        :options="optionDriver"
                        label="name"
                        :show-labels="false"
                        track-by="id">
                    </multiselect>
                    <button @click="searchDriver"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <router-link to="driver-form">
                        <button class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            เพิ่มคนขับ
                        </button>
                    </router-link>
                    &nbsp&nbsp
                    <button class="btn btn-primary my-2 my-sm-0"
                            v-if="canViewSuperAdmin"
                            @click="printDriverExcel"
                            type="button">
                        <icon name="print"></icon> รายงานคนขับรถ(Excel)
                    </button>
                    &nbsp;
                    <button type="button" class="btn btn-primary" @click="printDriverDetailsFromTransportType">
                        <icon name="print"></icon>
                        พิมพ์ค่าเที่ยว
                    </button>
                    &nbsp;
                    <button class="btn btn-info my-2 my-sm-0"
                            v-if="canViewSuperAdmin"
                            @click="getSettingTaxData"
                            type="button">
                        <icon name="plus"></icon>
                        ตั้งค่าภาษีคนขับรถ
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">บันทึกค่าเที่ยว</th>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ชื่อ-นามสกุล</th>
                    <th scope="col">ทะเบียนรถ</th>
                    <th scope="col">ประเภทรถ</th>
                    <th scope="col">วันที่หมดอายุ พรบ.</th>
                    <th scope="col">วันที่หมดอายุ ประกันภัย</th>
                    <th scope="col">วันที่หมดอายุ ภาษี</th>
                    <th scope="col">เบอร์โทรศัพท์</th>
                    <th scope="col">ดูข้อมูล</th>
                    <th scope="col">ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in driverList">
                    <td>
                        <a @click="showShippingForm(data.id)">
                            <img src="@/assets/plus_icon.png" width="40px"/>
                        </a>
                    </td>
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.license_plate }}</td>
                    <td>
                        <template v-if="data.transport_type">
                            {{ data.transport_type.name }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.car_act_date">
                            {{ data.car_act_date | moment("DD/MM/YYYY") }}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.insurance_date">
                            {{ data.insurance_date | moment("DD/MM/YYYY") }}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.tax_date">
                            {{ data.tax_date | moment("DD/MM/YYYY") }}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.phone">
                            {{ data.phone }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <button class="btn btn-info" @click="showDriverData(data.id)">
                            <icon name="pencil-alt"></icon>
                            ดูข้อมูล
                        </button>
                    </td>
                    <td>
                        <template v-if="data.cancel_status">
                            <div class="text-danger">คนขับถูกยกเลิกแล้ว</div>
                        </template>
                        <template v-else>
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash">
                                </icon>
                            </a>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="driverList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getDriverPage">
            </vue-pagination>
        </div>
        <br/>
        <!-- ---delete---- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <delete-driver-modal :money_driver="money_driver" @submit="deleteDriver"></delete-driver-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <!----------------is_auto_tax--------------->
        <b-modal hide-header hide-footer ref="setting_tax">
            <setting-tax-auto @submit="saveSettingTax"></setting-tax-auto>
        </b-modal>
        <!--        <pre class="alert alert-primary">{{ search }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import DriverModal from "./DriverShipping";
import VuePagination from "../../Pagination";
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import {domain} from "../../../util/Constants";
import Multiselect from "vue-multiselect";

import {canViewDriver, canViewDriverAll, canViewSuperAdmin,} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";
import SettingTaxAuto from "./SettingTaxAutoModal";
import DeleteDriverModal from "./DeleteDriverModal";

export default {
    components: {
        DeleteDriverModal,
        SettingTaxAuto,
        Loading,
        VuePagination,
        DatePicker,
        Multiselect,
        DriverModal
    },
    name: "driver-list",
    data() {
        return {
            msg: '',
            status_loading: '',
            delete_item: "",
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            money_driver: {}
        }
    },
    created() {
        this.$store.dispatch('Driver/setDriver', 1);
        this.$store.dispatch('TransportType/setTransportTypes');
        this.$store.dispatch('Driver/clearSearch');
        this.$store.dispatch('Driver/clearDriver');
        this.$store.dispatch('DriverDetails/clearDetails');
        this.$store.dispatch("Driver/getAll")
    },
    computed: {
        canViewDriver,
        canViewDriverAll,
        canViewSuperAdmin,
        ...mapState({
            driverList: state => {
                return state.Driver.driverList;
            },
            transportType: state => {
                return [
                    {
                        value: "",
                        text: "ค้นหาประเภทรถ"
                    },
                    ...state.TransportType.transportTypeList.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            dataPaginate: state => {
                return state.Driver.dataPaginate
            },
            search: state => {
                return state.Driver.search;
            },
            optionDriver: state => {
                return state.Driver.optionDriver;
            },
            user: state => {
                return state.Auth.user;
            },
        })
    },
    methods: {
        printDriverDetailsFromTransportType() {
            let start_date = '';
            let end_date = '';
            if (this.search.date.length < 1) {
                alert('กรุณาเลือกวันที่ก่อนพิมพ์');
            } else {
                if (this.search.date.length > 0 && this.search.date[0]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
                let data = {
                    transport_type: this.search.transport_type,
                    start_date,
                    end_date,
                    name: this.search.driver ? this.search.driver.name : null,
                }
                window.open(`${domain}/report_driver_details?transport_type_id=${data.transport_type}` +
                    `&start_date=${data.start_date}&end_date=${data.end_date}&name=${data.name}`, '_blank')
            }
        },
        showDeleteModal(id) {
            this.$store.dispatch('Driver/getRemaining', id).then(res => {
                this.money_driver = res;
                this.delete_item = id;
                this.$refs.delete_item.show();
            })
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showSettingTaxModal() {
            this.$refs.setting_tax.show();
        },
        hideSettingTaxModal() {
            this.$refs.setting_tax.hide();
        },
        getSettingTaxData() {
            this.$store.dispatch("Driver/getSettingTax").then(() => {
                this.showSettingTaxModal();
            });
        },
        saveSettingTax(value) {
            if (value) {
                this.msg = 'กำลังบันทึกข้อมูล กรุณารอสักครู่'
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("Driver/saveSettingTax", value).then(() => {
                    this.hideSettingTaxModal();
                    this.hideLoadingModal();
                })
            } else {
                this.hideSettingTaxModal();
            }
        },
        showDriverData(id) {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่'
            this.status_loading = 1;
            this.showLoadingModal();
            this.$store.dispatch('Driver/getDriverById', id).then(() => {
                this.$store.dispatch("DriverDetails/showDriverDetailsId", {
                    driver_id: id,
                    page: 1,
                }).then(() => {
                    this.$router.push({
                        name: "driver-form",
                        params: {id}
                    })
                    this.hideLoadingModal();
                }).catch(err => {
                    //console.log(err)
                    this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
                    this.status_loading = 3;
                })
            }).catch(err => {
                //console.log(err)
                this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
                this.status_loading = 3;
            })
        },
        showShippingForm(id) {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่'
            this.status_loading = 1;
            this.showLoadingModal();
            let date = moment().format("YYYY-MM-DD");
            this.$store.dispatch('Driver/show', id)
                .then(() => {
                    this.$store.dispatch('DriverDetails/setFilterInvoice', {
                        id,
                        date,
                    }).then(res => {
                        this.$store.dispatch('DriverDetails/driverShippingMonth',
                            {
                                driver_id: id,
                                date,
                                transportation_id: "",
                                transport_fee: res[0].transport_fee
                            });
                    }).then(() => {
                        this.$store.dispatch("DriverDetails/clearForm");
                        this.$router.push({
                            name: "driver-shipping",
                            params: {id}
                        })
                        this.hideLoadingModal();
                    }).catch(() => {
                        this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
                        this.status_loading = 3;
                    });
                })
        },
        deleteDriver(value) {
            if (value) {
                this.showLoadingModal();
                this.msg = 'กำลังลบข้อมูล กรุณารอสักครู่';
                this.status_loading = 1;
                value.user = this.user.name;
                this.$store.dispatch("Driver/delete", {
                    id: this.delete_item,
                    data: value
                }).then(() => {
                    this.hideDeleteModal();
                    this.$store.dispatch('Driver/setDriver', this.dataPaginate.current_page);
                    this.msg = 'ลบข้อมูลสำเร็จ';
                    this.status_loading = 2;
                }).catch(err => {
                    //console.log(err);
                    this.msg = 'ลบข้อมูลไม่สำเร็จ';
                    this.status_loading = 3;
                });
            }
            this.hideDeleteModal();
        },
        searchDriver() {
            const page = 1;
            this.event_submit = true;
            let data = {
                transport_type: this.search.transport_type,
                driver_id: this.search.driver ? this.search.driver.id : '',
                date: this.search.date,
            };
            if (this.search.driver) {
                this.search.driver_id = this.search.driver.id;
            }
            this.$store.dispatch('Driver/search', {
                page,
                data
            });
        },
        getDriverPage() {
            const page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.$store.dispatch('Driver/search', {
                    page: page,
                    data: this.search
                });
            } else {
                this.$store.dispatch('Driver/setDriver', page);
            }
        },
        printDriverExcel(){
            window.open(`${domain}/new-driver-excel`, '_blank')
        }
    }
}
</script>

<style scoped>

</style>
